var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"position":"absolute","top":"0px","left":"0px"},attrs:{"src":_vm.url,"id":"mobsf","scrolling":"auto","frameborder":"0","width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }